import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class AsnOrders_ds_get_shipmentlines_by_orderlineService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number, orderLineNumber: number }): 
  Promise<{ result: { Id?: number, ExpectedAmount?: number, ExpectedPackagedAmount?: number, ExpectedPackagedId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.orderLineNumber)) {
      missingRequiredInParams.push('\'orderLineNumber\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_shipmentlines_by_orderline/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderId: number, orderLineNumber: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpectedAmount?: number, ExpectedPackagedAmount?: number, ExpectedPackagedId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.orderLineNumber)) {
      missingRequiredInParams.push('\'orderLineNumber\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_shipmentlines_by_orderline/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderId: number, orderLineNumber: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpectedAmount?: number, ExpectedPackagedAmount?: number, ExpectedPackagedId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.orderLineNumber)) {
      missingRequiredInParams.push('\'orderLineNumber\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_shipmentlines_by_orderline/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number, orderLineNumber: number    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
        if(isNil(inParams.orderLineNumber)) {
          return true; 
        }
      return false;
    }
}
